const setLanguage = (payload) => {
  return {
    type: "bgChange",
    payload,
  };
};

export default setLanguage;
